import {
  CHILD_NAME,
  CHILD_SURNAME,
  CHILD_FATHER_NAME,
  CHILD_BITHDAY_DATE,
  CHILD_FAMILY_RELATION,
  CHILD_DOCUMENT_TYPE,
  CHILD_SERIES,
  CHILD_DOCUMENT_NUMBER,
  CHILD_DATE_OF_ISSUE,
  CHILD_ISSUED_BY,
  CHILD_ACT_NUMBER,
  CHILD_GENDER,
  CHILD_ACT_DATE,
  CHILD_CARE_DATE,
  SET_CHILD,
  CHANGE_CHILD,
  CLEAR_CHILD_DATA,
  CHILD_UNZR_NUMBER,
  CHILD_RNOKPP
} from '../actions/types';

const initialState = {
  name: "",
  surname: "",
  fathername: "",
  bithdaydate: "",
  relation_id: "",
  documenttype: "",
  series: "",
  documentnumber: "",
  documentdate: "",
  issuedby: "",
  reg_number: "",
  gender: "",
  reg_date: "",
  adopted_date: "",
  id: "0",
  applicant_id: "",
  scanname: "0",
  unzrNumber: '',
  rnokpp: '',
};

export default function(state = initialState, action) {
  switch (action.type) {
    case CHANGE_CHILD:
      return {
        ...state,
        ...action.data
      };
    case SET_CHILD:
      return {
        ...state,
        ...action.payload
      };
    case CLEAR_CHILD_DATA:
      return {
        ...state,
        ...initialState
        // name: action.name,
        // surname: action.surname,
        // fathername: action.fathername,
        // bithdaydate: action.bithdaydate,
        // relation_id: action.relation_id,
        // documenttype: action.documenttype,
        // series: action.series,
        // documentnumber: action.documentnumber,
        // documentdate: action.documentdate,
        // issuedby: action.issuedby,
        // reg_number: action.reg_number,
        // gender: action.gender,
        // reg_date: action.reg_date,
        // adopted_date: action.adopted_date,
        // id: action.id,
        // usznNumber: action.
      };
    case CHILD_NAME:
      return {
        ...state,
        name: action.payload
      };
    case CHILD_SURNAME:
      return {
        ...state,
        surname: action.payload
      };
    case CHILD_FATHER_NAME:
      return {
        ...state,
        fathername: action.payload
      };
    case CHILD_BITHDAY_DATE:
      return {
        ...state,
        bithdaydate: action.payload
      };
    case CHILD_FAMILY_RELATION:
      return {
        ...state,
        relation_id: action.payload
      };
    case CHILD_DOCUMENT_TYPE:
      return {
        ...state,
        documenttype: action.payload
      };
    case CHILD_SERIES:
      return {
        ...state,
        series: action.payload
      };
    case CHILD_DOCUMENT_NUMBER:
      return {
        ...state,
        documentnumber: action.payload
      };
    case CHILD_DATE_OF_ISSUE:
      return {
        ...state,
        documentdate: action.payload
      };
    case CHILD_ISSUED_BY:
      return {
        ...state,
        issuedby: action.payload
      };
    case CHILD_ACT_NUMBER:
      return {
        ...state,
        reg_number: action.payload
      };
    case CHILD_GENDER:
      return {
        ...state,
        gender: action.payload
      };
    case CHILD_ACT_DATE:
      return {
        ...state,
        reg_date: action.payload
      };
    case CHILD_CARE_DATE:
      return {
        ...state,
        adopted_date: action.payload
      };
    case CHILD_UNZR_NUMBER:
      return {
        ...state,
        unzrNumber: action.payload
      };
    case CHILD_RNOKPP:
      return {
        ...state,
        rnokpp: action.payload
      };
    default:
      return state;
  }
}
